import { screenshotEventName } from "@/lib/events";
import { Sounds, playSound } from "@/lib/sound";
import { showSideBar, volume } from "@/state/config";
import { screenshotDataURL } from "@/state/recording";
import { stream } from "@/state/stream";
import { type FunctionalComponent, createRef } from "preact";
import { useEffect } from "preact/hooks";

const Video: FunctionalComponent = () => {
    const canvasRef = createRef<HTMLCanvasElement>();
    const videoRef = createRef<HTMLVideoElement>();

    const toggleSidebar = () => {
        showSideBar.value = !showSideBar.value;
    };

    const doScreenshot = () => {
        if (!canvasRef.current) return;
        if (!videoRef.current) return;

        canvasRef.current.width = videoRef.current.videoWidth;
        canvasRef.current.height = videoRef.current.videoHeight;

        const context = canvasRef.current.getContext("2d");
        if (!context) return;
        context.drawImage(videoRef.current, 0, 0);

        playSound(Sounds.Camera);

        const dataURL = canvasRef.current.toDataURL("image/webp");

        screenshotDataURL.value = dataURL;
    };

    useEffect(() => {
        const listener = () => {
            doScreenshot();
        };

        window.addEventListener(screenshotEventName, listener);

        return () => {
            window.removeEventListener(screenshotEventName, listener);
        };
    });

    useEffect(() => {
        if (!videoRef.current) return;

        videoRef.current.onloadedmetadata = () => {
            if (!videoRef.current) return;
            videoRef.current.play();
        };
    }, [videoRef.current]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (!videoRef.current) return;
        videoRef.current.srcObject = stream.value;
    }, [videoRef.current, stream.value]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (!videoRef.current) return;
        videoRef.current.volume = volume.value;
    }, [videoRef.current, volume.value]);

    return (
        <>
            <canvas ref={canvasRef} style="display:none;" />
            <video autoplay={true} ref={videoRef} class="aspect-video w-full" onClick={toggleSidebar} />
        </>
    );
};

export default Video;
